/**
 * The reason an edge function gave for refusing, when it gave one.
 *
 * supabase-js reports every non-2xx as the same sentence -- "Edge Function returned a non-2xx
 * status code" -- and hangs the actual Response off `context`. The functions that manage logins
 * answer with `{ success: false, error }`, and that `error` is written to be read by the person
 * at the form: "That email isn't set up for a new account", not a status code.
 */
export async function edgeFunctionError(error: unknown): Promise<string | null> {
  const context = (error as { context?: unknown }).context
  if (!(context instanceof Response)) return null
  try {
    const answer = (await context.clone().json()) as { error?: unknown }
    return typeof answer.error === "string" && answer.error.trim() ? answer.error : null
  } catch {
    return null
  }
}
